import { actions } from '../../utils/constants';

export const initVideoData = (classId, videoUrl, data) => {
    return {
        type: actions.ASYNC_INIT_VIDEO_DATA,
        payload: {
            classId,
            videoUrl,
            data,
        },
    };
};

export const updateVideoData = (classId, videoUrl, data) => {
    return {
        type: actions.ASYNC_UPDATE_VIDEO_DATA,
        payload: {
            classId,
            videoUrl,
            data,
        },
    };
};

export const updateActivity = (classId, value) => ({
    type: actions.ASYNC_UPDATE_ACTIVITY,
    payload: {
        classId,
        value,
    },
});

export const uploadFile = (dataUri, cb = () => {}, mime) => ({
    type: actions.UPLOAD_FILE,
    payload: {
        dataUri,
        cb,
        mime,
    },
});

export const submitTCC = (classId, tccId) => ({
    type: actions.ASYNC_SUBMIT_TCC,
    payload: {
        classId,
        tccId,
    },
});

export const updateModuleDates = (classId, tccId, firstModEnd, secondModEnd, masterEnd) => ({
    type: actions.ASYNC_UPDATE_MODULE_DATES,
    payload: {
        classId,
        tccId,
        firstModEnd,
        secondModEnd,
        masterEnd,
    },
});

export const clickInAttach = ( classId, fileId) => ({
    type: actions.ASYNC_DOWNLOAD_ATTACH,
    payload: { classId, fileId },
});



// WEBPACK FOOTER //
// ./src/components/section/section.actions.js